import { useAsync } from 'react-use';

import {
  discoveryApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export const useSecurityGroupNames = (
  groupIds: string[],
): {
  groups: Map<string, string>;
  loading: boolean;
  error: Error | undefined;
} => {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const {
    value: groups,
    loading,
    error,
  } = useAsync(async () => {
    if (!groupIds || groupIds.length === 0) {
      return new Map<string, string>();
    }

    const baseUrl = await discoveryApi.getBaseUrl('azure-resources-common');
    const { token } = await identityApi.getCredentials();

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${baseUrl}/security-groups/resolve`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ ids: groupIds }),
    });

    if (!response.ok) {
      throw new Error(
        `Failed to resolve security groups: ${response.statusText}`,
      );
    }

    const data = await response.json();
    const map = new Map<string, string>();
    for (const [id, name] of Object.entries(data.groups)) {
      if (name) {
        map.set(id, name as string);
      }
    }
    return map;
  }, [groupIds.join(',')]);

  return {
    groups: groups ?? new Map<string, string>(),
    loading,
    error,
  };
};
